import { render, staticRenderFns } from "./customBlock.vue?vue&type=template&id=564f2baa"
import script from "./customBlock.vue?vue&type=script&lang=js"
export * from "./customBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports